const levels = [
  {
    num: 1,
    title: 'Реакция участников',
    subtitle: 'Понравилось ли обучение',
    items: [
      'Анкетирование сразу после тренинга',
      'Оценка качества материалов, тренера, организации',
      'Эмоциональная вовлечённость участников',
    ],
    example: 'После тренинга продаж 93% участников оценили его на 4,7 из 5. Но это лишь первый слой — эмоции не гарантируют результат.',
    color: 'bg-teal-100 border-teal-300',
    iconBg: 'bg-teal-500',
    icon: 'ri-emotion-happy-line',
  },
  {
    num: 2,
    title: 'Полученные знания',
    subtitle: 'Что сотрудники усвоили',
    items: [
      'Тестирование до и после обучения',
      'Оценка прироста знаний в процентах',
      'Проверка понимания методик и алгоритмов',
    ],
    example: 'Средний прирост знаний после тренинга переговоров составил 47%: с 52% правильных ответов до тренинга до 76% после. Но знание техник не равно их применению.',
    color: 'bg-teal-100 border-teal-300',
    iconBg: 'bg-teal-600',
    icon: 'ri-book-open-line',
  },
  {
    num: 3,
    title: 'Изменение поведения',
    subtitle: 'Что изменилось в работе',
    items: [
      'Наблюдение руководителя за работой сотрудника',
      'Оценка 360 градусов до и после обучения',
      'Аудит звонков, встреч, переговоров',
    ],
    example: 'Через 2 месяца после тренинга продаж менеджеры стали использовать 6 из 8 изученных техник. Конверсия встреч выросла на 22%. Вот где начинается реальная эффективность.',
    color: 'bg-teal-200 border-teal-400',
    iconBg: 'bg-teal-700',
    icon: 'ri-user-settings-line',
  },
  {
    num: 4,
    title: 'Результаты бизнеса',
    subtitle: 'Рост продаж, прибыли, KPI',
    items: [
      'Сравнение KPI до и после обучения',
      'Расчёт ROI: прибыль / затраты на обучение',
      'Влияние на выручку, текучесть, NPS, производительность',
    ],
    example: 'Через 4 месяца после внедрения программы обучения отдела продаж: конверсия выросла с 14% до 21%, средний чек — на 18%, выручка отдела — на 34%. ROI составил 520%.',
    color: 'bg-teal-300 border-teal-500',
    iconBg: 'bg-teal-800',
    icon: 'ri-line-chart-line',
  },
];

export default function KirkpatrickModel() {
  return (
    <section id="kirkpatrick" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Модель Киркпатрика — стандарт оценки эффективности обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Самая признанная в мире модель оценки корпоративного обучения. Четыре уровня — от эмоций участников до измеримого бизнес-результата. Реальная эффективность начинается с третьего уровня.
        </p>

        <div className="max-w-4xl mx-auto space-y-0">
          {levels.map((l, i) => (
            <div key={i} className="relative">
              <div className={`${l.color} rounded-2xl p-6 md:p-8 border`}>
                <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6">
                  <div className={`${l.iconBg} w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0`}>
                    <i className={`${l.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-sm font-bold text-teal-700 bg-white/80 px-3 py-1 rounded-full">Уровень {l.num}</span>
                      <h3 className="text-xl md:text-2xl font-bold text-gray-900">{l.title}</h3>
                    </div>
                    <p className="text-gray-600 font-semibold mb-3">{l.subtitle}</p>
                    <ul className="space-y-1.5 mb-4">
                      {l.items.map((item, j) => (
                        <li key={j} className="flex items-start gap-2 text-sm text-gray-700">
                          <span className="w-1.5 h-1.5 bg-teal-600 rounded-full flex-shrink-0 mt-1.5"></span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="bg-white/60 rounded-lg p-4 border border-white">
                      <p className="text-sm text-gray-700 leading-relaxed italic">{l.example}</p>
                    </div>
                  </div>
                </div>
              </div>
              {i < levels.length - 1 && (
                <div className="flex justify-center py-2">
                  <div className="w-0.5 h-8 bg-teal-300"></div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto mt-12 bg-teal-600 rounded-2xl p-6 md:p-8 text-center">
          <p className="text-white text-lg md:text-xl font-bold leading-relaxed">
            Компании, которые доходят до оценки уровней 3 и 4, получают в 3-5 раз больше отдачи от обучения, чем те, кто останавливается на анкетах удовлетворённости.
          </p>
        </div>
      </div>
    </section>
  );
}